// extracted by mini-css-extract-plugin
export default {"studioCtaTooltip":"LWsyjb","studioCta":"kTK70c","light":"Nk8H_b","filled":"a6bFAW","disabled":"oWlgUq","newUi":"W7OAot","small":"nCpct5","medium":"H2_lPR","large":"VT7_cG"};